"use strict";
import React from "react";
import { Link } from "dva/router";
import "./index.less";
const NumItem = (props) => {
  return /* @__PURE__ */ React.createElement("div", { className: "num-item" }, /* @__PURE__ */ React.createElement("div", { className: "number" }, props.to ? /* @__PURE__ */ React.createElement(Link, { to: props.to }, props.number || 0) : /* @__PURE__ */ React.createElement("span", null, props.number || 0)), /* @__PURE__ */ React.createElement("div", { className: "title" }, props.title));
};
export default NumItem;
